import React from 'react';
import CommentViewBase from './CommentViewBase';

export default function AllQueryCommentView(props) {
    return (
        <CommentViewBase
            {...props}
            mode="fy"
            commentRoutePath="/comment"
            includeRecipientSelection={true}
        />
    );
}
